<template>
    <div>
      <footer class="footer">
        <div class="content has-text-centered">
          <p>
            <strong>Digital marketing tools</strong> by <a href="https://www.novicell.co.uk">Novicell</a>
          </p>
      </div>
    </footer>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer {
  margin-top: 3rem;
  background-color: #F5F5F5
}
</style>
